<template>
  <div class="wrapper">
    <div id="app">
      <Header></Header>
      <transition v-on:before-enter="beforeEnter"
        name="fade-in-right"
        mode="out-in"
        :duration="{ enter: 300, leave: 100 }"
      >
        <!-- <vue-page-transition name="fade-in-right"> -->
        <router-view />
      </transition>
      <!-- </vue-page-transition> -->
      <!-- <Footer></Footer> -->
      <section class="tableContentsInner">
        <a href="#" @click.stop.prevent="closeTableContents" class="exit">
          <i class="fas fa-times-circle"></i>
        </a>
        <tableOfContentsMenu></tableOfContentsMenu>
      </section>
      <!-- sideLinks -->
      <sideLinks></sideLinks>
      <!-- sideLinks -->
    </div>
  </div>
</template>
<script>
// import VuePageTransition from 'vue-page-transition'
import tableOfContentsMenu from "@/components/common/tableOfContentsMenu.vue";
import sideLinks from "@/components/common/sideLinks.vue";
import Header from "@/components/common/header.vue";
export default {
  components: {
    tableOfContentsMenu,
    sideLinks,
    Header
  },
  methods: {
    closeTableContents() {
      document.body.parentNode.classList.remove('overflow-hidden')
      document.body.classList.remove("isVisible");
    },
    beforeEnter() {
      this.closeTableContents();
    }
  },
  created: function() {
      
    if (this.$i18n.locale == "ar") {
      document.getElementsByTagName("html")[0].lang = "ar";
      document.getElementsByTagName("html")[0].classList.add("ar");
    }
  }
};
</script>
<style>
@keyframes fadeInRight {
  from {
    transform: translate3d(20%, 0, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.fade-in-right-leave-to {
  opacity: 0;
  transition: all 0.5s ease;
  transform: translate3d(-20%, 0, 0);
}

.fade-in-right-enter {
  opacity: 0;
  transform: translate3d(20%, 0, 0);
}

.fade-in-right-enter-to {
  opacity: 0;
  animation-duration: 0.7s;
  animation-fill-mode: both;
  animation-name: fadeInRight;
}

@keyframes fadeInDown {
  from {
    transform: translate3d(0, -40px, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.fade-in-down-leave-to {
  opacity: 0;
  transition: opacity 0.3s;
}

.fade-in-down-enter {
  opacity: 0;
  transform: translate3d(0, -40px, 0);
}

.fade-in-down-enter-to {
  opacity: 0;
  animation-duration: 0.7s;
  animation-fill-mode: both;
  animation-name: fadeInDown;
}
</style>
<style lang="scss">
#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.tableContentsInner {
  position: fixed;
  left: -100%;
  transition: all 0.8s ease;
  width: 100%;
  height:100vh;
  top: 0px;
  z-index: 9999;
  .tableContents{
        background-attachment: inherit !important;
        @media screen and (max-width:575px){
          padding-bottom:0 !important;
        }
    h1{
      @media screen and (max-width:575px){
        padding-top:0;
      }
    }
  }
  .exit {
    position: absolute;
    top: 25px;
    right: 35px;
    font-size: 25px;
    color: #000;
    &:hover {
      opacity: 0.8;
    }
  }
  .graphics {
    display: none !important;
  }
  @media screen and (max-width: 991px) {
    .tableContents {
      padding-top: 50px !important;
    }
  }
  @media screen and (max-width: 767px) {
    padding-top: 0 !important;
    .exit {
      top: 15px;
      right: 20px;
    }
  }
}

// ar style

.ar{
  .tableContentsInner {
    right: -100%;
    left: auto;
    .exit {
      left: 35px;
      right: auto;
    }
    @media screen and (max-width: 767px) {
      padding-top: 0 !important;
      .exit {
        left: 25px;
        right: auto;
      }
    }
  }
  }
  </style>
<style lang="scss">
.overflow-hidden{
  overflow:hidden;
}
.isVisible {
  overflow: hidden;
  z-index:-1;
  .tableContentsInner {
    left: 0;
  }
}
.ar{
  .isVisible {
    .tableContentsInner {
      right: 0;
      left: auto;
    }
  }
}
</style>
